import axios from 'axios';
import authHeader from "@/service/auth-header";

class StorageService {

    getCompanyStorage(companyId) {
        return axios.get('/api/storage/hetzner', {
            headers: authHeader(),
            params: {
                companyId: companyId
            }
        });
    }

    getCompanyStorageForClient(companyId, clientId) {
        return axios.get('/api/storage/hetzner/client', {
            headers: authHeader(),
            params: {
                companyId: companyId,
                clientId: clientId
            }
        });
    }

    getCompanyStorageForTask(companyId, taskId) {
        return axios.get('/api/storage/hetzner/task', {
            headers: authHeader(),
            params: {
                companyId: companyId,
                taskId: taskId
            }
        });
    }

    deleteCompanyStorage(id) {
        return axios.delete('/api/storage/hetzner', {
            headers: authHeader(),
            params: {
                id: id
            }
        });
    }

    downloadFile(companyId, id) {
        return axios.get('/api/storage/hetzner/download', {
            headers: authHeader(),
            params: {
                companyId: companyId,
                id: id
            },
            responseType: 'blob'
        });
    }

    async addExternalFile(id, data) {
        return await axios.post(`/api/storage/external/add/${id}`, data, {headers: authHeader()});
    }

    async updateCompanyStorage(id, data) {
        return await axios.put(`/api/storage/${id}`, data, {headers: authHeader()});
    }

    getCompanyFilesSharePoint(companyId) {
        return axios.get('/api/storage/sharepoint', {
            headers: authHeader(),
            params: {
                companyId: companyId
            }
        });
    }

    getCompanyFilesSharePointForClient(companyId, clientId) {
        return axios.get('/api/storage/sharepoint/client', {
            headers: authHeader(),
            params: {
                companyId: companyId,
                clientId: clientId
            }
        });
    }
}

export default new StorageService();
